module.exports = __webpack_public_path__ + "img/c-logo.d29112fc.png";